import { IError } from '../../httpClient/serverApi/types/IError';

export class ListResultWithToken<T> {

  public items: T[];
  public nextPageToken: string;
  public errors?: IError[];
  public total?: number;
  public moreItems?: boolean;

  constructor(items: T[], nextPageToken: string, errors?: IError[], total?: number, moreItems?: boolean) {
    this.items = items;
    this.nextPageToken = nextPageToken;
    this.errors = errors || [];
    this.total = total;
    this.moreItems = moreItems;
  }

  static empty<T>(): ListResultWithToken<T> {
    return new ListResultWithToken<T>([], null);
  }

}